import { render, staticRenderFns } from "./CustomerSOA.vue?vue&type=template&id=c2b3fa4e&scoped=true"
import script from "./CustomerSOA.vue?vue&type=script&lang=js"
export * from "./CustomerSOA.vue?vue&type=script&lang=js"
import style0 from "./CustomerSOA.vue?vue&type=style&index=0&id=c2b3fa4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b3fa4e",
  null
  
)

export default component.exports